import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { DefaultNotificationService } from './default-notification-service';

const messages = defineMessages({
  errorTitle: {
    description: 'inventoryExport.errorNotificationTitle',
    defaultMessage: 'Inventory Export Error',
    id: 'tNxNfb',
  },
  errorContent: {
    description: 'inventoryExport.errorNotificationContent',
    defaultMessage: 'There was an error trying to export the inventory. Please try again.',
    id: 'cG5fC1',
  },
});

class InventoryExportNotificationServiceClass {
  get pusherMessageKey() {
    return 'Inventory Export';
  }

  validateMessage(message) {
    if (!message || !message.Notification || !message.Notification.Title) {
      return false;
    }

    return message.Notification.Title.includes(this.pusherMessageKey);
  }

  processMessage(message) {
    if (!message) {
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.errorTitle} />,
        content: <FormattedMessage {...messages.errorContent} />,
        notificationType: NOTIFICATION_TYPE_ERROR,
        dontHide: true,
      });
    }

    DefaultNotificationService.displayNotification(message.Notification);
  }
}

export const InventoryExportNotificationService = new InventoryExportNotificationServiceClass();
